export default "__VITE_ASSET__B8UU6NNW__"